var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68609 13.2265C7.99526 12.9173 7.99526 12.416 7.68609 12.1069C7.37693 11.7977 6.87567 11.7977 6.56651 12.1069L3.39984 15.2735C3.09068 15.5827 3.09068 16.084 3.39984 16.3931C3.70901 16.7023 4.21026 16.7023 4.51943 16.3931L7.68609 13.2265Z",
    fill: "#3699FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.832 8.70768C15.832 11.7683 13.3509 14.2493 10.2904 14.2493C7.22979 14.2493 4.7487 11.7683 4.7487 8.70768C4.7487 5.6471 7.22979 3.16602 10.2904 3.16602C13.3509 3.16602 15.832 5.6471 15.832 8.70768ZM6.33203 8.70768C6.33203 10.8938 8.10424 12.666 10.2904 12.666C12.4765 12.666 14.2487 10.8938 14.2487 8.70768C14.2487 6.52156 12.4765 4.74935 10.2904 4.74935C8.10424 4.74935 6.33203 6.52156 6.33203 8.70768Z",
    fill: "#3699FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.52ac158c.svg";
export { ForwardRef as ReactComponent };